<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },

    description: {
      type: String,
      required: false,
      default: '',
    },

    value: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<template>
  <div
    class="bdk-checkbox bdk-relative bdk-flex bdk-items-start"
  >
    <label
      class="bdk-flex bdk-items-center bdk-h-5 bdk-cursor-pointer"
    >
      <input
        :key="value"
        type="checkbox"
        :checked="value"
        @click.prevent="$emit('input', ! value)"
        class="form-checkbox focus:bdk-ring-indigo-500 bdk-h-4 bdk-w-4 bdk-text-indigo-600 bdk-border-gray-300 bdk-rounded"
      />

      <div
        class="bdk-ml-2 bdk-text-sm"
      >
        <span
          v-if="label"
          v-text="label"
          class="bdk-font-medium bdk-text-gray-700"
        />

        <span
          v-if="description"
          v-text="description"
          class="bdk-text-gray-500"
        />
      </div>
    </label>
  </div>
</template>
